import { Routes } from 'business/router/constants';
import { useNavigate } from 'react-router';

export const PageTitle = ({ title }: { title: string }) => {
  const navigate = useNavigate();

  return (
    <h1
      className="text-primary text-lg font-bold uppercase select-none"
      onClick={() => navigate(Routes.App)}
    >
      {title}
    </h1>
  );
};
